import { useRequestProcessing } from '@gogame/query';

import {
  importNewFromGoogleDrive,
  checkLoadStatus,
  loadFileId,
} from 'scenes/MarketingPlanning/MarketingPlanningGrid/sources/marketingPlanning';

import { importNewFromGoogleDrive as importNewFromGoogleDriveKey } from '../queryKeyFactory';
import { messagesPlan } from '../messages';

const loadFile = ({ jobId }) =>
  loadFileId({ jobId }).then(({ fileId }) => {
    window.open(`https://docs.google.com/spreadsheets/d/${fileId}`, '_blank');
  });

export const useImportNewPlanFromGooglePicker = ({
  onSuccess,
  onHasErrors,
}) => {
  const importMessage = messagesPlan.import();
  return useRequestProcessing(
    importNewFromGoogleDriveKey(),
    importNewFromGoogleDrive,
    checkLoadStatus,
    {
      refresh: false,
      getCompletedMessage: () => importMessage.completed(),
      getHasErrorsMessage: () => importMessage.completedWithErrors(),
      getFailedMessage: () => importMessage.failed(),
      getProcessMessage: (result) =>
        importMessage.processing(result?.percentCompleted),
      onCompleted: onSuccess,
      onHasErrors: (_, { jobId }) => {
        onHasErrors();
        loadFile({ jobId });
      },
    }
  );
};
